module.exports = __webpack_public_path__ + "static/media/icon-ppt.ed9d493d.svg";